"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.drawProductMask = void 0;
const helpers_1 = require("../helpers");
const maskComposition = {
    multiplyImageUrl: 'multiply',
    clipImageUrl: 'destination-in',
    overImageUrl: 'source-over',
};
function drawProductMask(context, { product, productMasks, contents }, assetCache) {
    [
        'multiplyImageUrl',
        'clipImageUrl',
        'overImageUrl'
    ].forEach(mask => {
        const maskUrl = productMasks[mask];
        if (!maskUrl) {
            return;
        }
        const maskImage = assetCache.getImage(maskUrl);
        if ((0, helpers_1.isValidImage)(maskImage)) {
            context.save();
            context.translate(product.x, product.y);
            context.globalCompositeOperation = maskComposition[mask];
            const image = contents[0].image;
            // rotate masks for landscape images because the masks are in a portrait orientation
            const shouldRotate = image.width / image.height > 1;
            if (shouldRotate) {
                // move to where the center of the image should be
                context.translate(product.width / 2, product.height / 2);
                // rotate 90 degrees
                context.rotate(Math.PI / 2);
                // move back
                context.translate(-product.height / 2, -product.width / 2);
                // draw the image in the new orientation
                context.drawImage(maskImage, 0, 0, product.height, product.width);
            }
            else {
                context.drawImage(maskImage, 0, 0, product.width, product.height);
            }
            context.restore();
        }
    });
}
exports.drawProductMask = drawProductMask;
